module.exports = __webpack_public_path__ + "media/application/images/2018/rd-2020-footer-instagram-8f8f5f2bd2faf75764d6498edf064126.png";